import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import Iconify from '../../../components/iconify';
import { firstAllowedPath } from '../../../protectedRoute';

export default function LoginForm() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    const emailNorm = email.trim().toLowerCase();

    // Admins legacy (acceso total)
    const ADMIN_EMAILS = ['admin@bbtargetcenterpr.com', 'islandlens@gmail.com'];
    if (ADMIN_EMAILS.includes(emailNorm) && password === 'Tiro@123!!') {
      localStorage.removeItem('employee');
      localStorage.setItem('adminEmail', emailNorm);
      localStorage.setItem('token', '123456');
      navigate('/dashboard/user', { replace: true });
      return;
    }

    // Empleados (colección employees): entra con email o username; respeta
    // cuenta activa y guarda sus permisos para protectedRoute.
    setLoading(true);
    try {
      const db = getFirestore();
      let snap = await getDocs(query(collection(db, 'employees'), where('email', '==', emailNorm)));
      if (snap.empty) {
        snap = await getDocs(query(collection(db, 'employees'), where('username', '==', email.trim())));
      }
      const empDoc = snap.docs[0];
      const emp = empDoc ? empDoc.data() : null;
      if (emp && emp.password && emp.password === password && emp.active !== false) {
        localStorage.setItem('employee', JSON.stringify({
          id: empDoc.id,
          name: emp.name || '',
          email: emp.email || '',
          role: emp.role || 'employee',
          permissions: emp.permissions || {},
        }));
        localStorage.setItem('token', `emp_${empDoc.id}`);
        // Redirigir a la primera sección que sus permisos le permiten ver
        navigate(firstAllowedPath() || '/dashboard/user', { replace: true });
        setLoading(false);
        return;
      }
    } catch (e) {
      console.error('Employee login error:', e);
    }
    setLoading(false);
    alert('Invalid email or password');
  };

  return (
    <>
      <Stack spacing={3}>
        <TextField name="email" label="Email o usuario" value={email} onChange={(e) => setEmail(e.target.value)}/>

        <TextField
          name="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') handleLogin(); }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        <Checkbox name="remember" label="Remember me" />
        <Link variant="subtitle2" underline="hover">
          Forgot password?
        </Link>
      </Stack>

      <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleLogin} loading={loading}>
        Login
      </LoadingButton>
    </>
  );
}
